import React, {Component} from "react";
import MaterialIcon from '../MaterialIcon';
import Popup from "reactjs-popup";
import popupStyles from "../../utils/popupConfig";
import {FormattedMessage} from 'react-intl';

class SecondaryMenu extends Component {
    render() {
        return (
            <div className="secondary-menu">
                <div className="command-panel">
                    <div className="command-group">
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div className={"command" + (this.props.isReadOnly ? "" : " active")}
                                          onClick={() => this.props.onImportClick()}><MaterialIcon icon="upload"/>
                            </div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Import"/></span>
                        </Popup>
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div className={"command" + (this.props.anySelected && this.props.anySelected.isSelected ? " active" : "")}
                                          onClick={() => this.props.onExportClick()}><MaterialIcon icon="download"/>
                            </div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Export"/></span>
                        </Popup>
                    </div>

                    <div className="command-group">
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div className={"command" + (this.props.anySelected && !this.props.isReadOnly && this.props.anySelected.isSelected ? " active" : "")}
                                          onClick={() => this.props.onDeleteClick()}><MaterialIcon icon="delete"/>
                            </div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Delete"/></span>
                        </Popup>
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div className={"command" + (this.props.anySelected && !this.props.isReadOnly && this.props.anySelected.isSelected ? " active" : "")}
                                          onClick={() => this.props.onClone()}><MaterialIcon icon="filter_none"/></div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Clone"/></span>
                        </Popup>
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div onClick={() => this.props.onGoLive()}
                                          className={"command" + (this.props.anySelected && !this.props.isReadOnly && this.props.anySelected.isSelected
                                          && this.props.anySelected.type  !== "COMPONENT" ? " active" : "")}>
                                <MaterialIcon
                                    icon="play_arrow"/></div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Go Live"/></span>
                        </Popup>
                        <Popup
                            contentStyle={popupStyles.contentStyle}
                            arrowStyle={popupStyles.arrowStyle}
                            trigger={<div onClick={() => this.props.onPauseLive()}
                                          className={"command" + (this.props.anySelected && !this.props.isReadOnly && this.props.anySelected.isSelected
                                          && this.props.anySelected.type !== "COMPONENT" ? " active" : "")}>
                                <MaterialIcon
                                    icon="pause"/></div>}
                            position="bottom center"
                            on="hover">
                            <span><FormattedMessage id="Pause"/></span>
                        </Popup>
                    </div>
                </div>

                <div className="analytics-menu-wrapper">
                    <div className="search-area">
                        <FormattedMessage id="Search">
                            {placeholder =>
                                <input
                                    placeholder={placeholder}
                                    type="text"
                                    name="search"
                                    className="main-search-input"
                                    value={this.props.searchValue}
                                    onChange={this.props.onSearchValueChange}
                                />
                            }
                        </FormattedMessage>
                        <MaterialIcon icon="search"/>
                    </div>
                    <button className="add-graph-button"
                            onClick={() => {this.props.updateAddLogicInputVisibility()}}
                            disabled={this.props.isReadOnly}
                    >
                        <MaterialIcon icon="add" size={24}/>
                        <span><FormattedMessage id="Add new Logic"/></span>
                    </button>
                </div>
            </div>
        );
    }
}

export default SecondaryMenu;
